import React from 'react';
import * as w from '@packages/systems/wfdl';
import * as wast from '@packages/systems/wfdl-ast';
import {
  ContextualExpressions,
  getAnn,
  stripAnn,
} from '@packages/utilities/contextual-expression';

import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {updateExpressionAction} from '@packages/systems/ExpressionEditor-utils';
import {Checkbox} from '@packages/systems/spring';

const defaultSystem: Record<string, any> = {};

export const CheckboxAliasType = w.TypeImplementation.Alias({
  type: wast.TTypeConstructor(
    qualify(w.Plugins.name('Boolean'), typeName('Boolean'))
  ),
  render: ({expr, dispatch}) => {
    const type = getAnn(expr)?.type;
    const maybeSystem = type ? w.getSystem(type) : null;
    const system = maybeSystem ? maybeSystem : defaultSystem;

    const union = ContextualExpressions.getUnion(stripAnn(expr));
    const isChecked = union ? union.tag === 'True' : false;

    return (
      <Checkbox
        aria-label={system.label || 'Yes'}
        isChecked={isChecked}
        data-automation-id={`${
          type ? w.Types.generateAutomationIds(type) : 'boolean-primitive'
        }`}
        onChange={() => {
          const newValue = isChecked ? 'False' : 'True';
          dispatch(
            updateExpressionAction(
              wast.EUnion({tag: newValue, value: wast.ERecord({})})
            )
          );
        }}
      />
    );
  },
  system: {defaultValue: false, label: 'Switch', bindUIVariant: 'custom'},
});
